import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.608.161a.5.5 0 0 0-.545.108L19.472 2.86a.25.25 0 0 1-.292.045 12.54 12.54 0 0 0-12.966.865A12.26 12.26 0 0 0 6.1 23.632a1.25 1.25 0 0 0 1.476-2.018 9.76 9.76 0 0 1 .091-15.809 10 10 0 0 1 9.466-1.1.25.25 0 0 1 .084.409l-1.85 1.85a.5.5 0 0 0 .354.853h6.7a.5.5 0 0 0 .5-.5V.623a.5.5 0 0 0-.313-.462" }, null, -1)
  ]))]))
}
export default { render: render }